import { forwardRef } from 'react';

import * as DialogPrimitive from '@radix-ui/react-dialog';
import { twMerge } from 'tailwind-merge';

const ModalContent = forwardRef<HTMLDivElement, DialogPrimitive.DialogContentProps>(function ModalContent({ className, ...props }, ref) {
  return (
    <DialogPrimitive.DialogContent
      ref={ref}
      {...props}
      className={twMerge(
        'fixed left-2/4 top-2/4 z-50 w-11/12 -translate-x-2/4 -translate-y-2/4',
        'md:w-screen',
        'max-w-4xl overflow-auto focus:outline-none',
        'rounded-md bg-white font-serif shadow-md',
        '-mt-8',
        className,
      )}
    />
  );
});

export { ModalContent };
